import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// import { Provider } from "react-redux";
// import { store } from "./store/store";
import reportWebVitals from "./reportWebVitals";
import SimpleReactLightbox from "simple-react-lightbox";
import ThemeContext from "./context/ThemeContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import NiceModal from "@ebay/nice-modal-react";

import CustomRouter from "./utils/helpers/customRouter";

import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: "always",
      retry: false,
      staleTime: 60000,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.render(
  // <React.StrictMode>
  // <Provider store={store}>
  <QueryClientProvider client={queryClient}>
    <SimpleReactLightbox>
      <NiceModal.Provider>
        <CustomRouter history={history}>
          <ThemeContext>
            <App />
          </ThemeContext>
        </CustomRouter>
      </NiceModal.Provider>
    </SimpleReactLightbox>
  </QueryClientProvider>,
  // </Provider>,
  // </React.StrictMode>,
  document.getElementById("root")
);
reportWebVitals();
